import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { CheckboxHeader, CheckboxCell } from './checkbox-components';
import style from '../style.module.css';

export const createCheckboxColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'isSelected',
  className: style['checkbox-column'],
  id: 'checkbox',
  Header: CheckboxHeader,
  Cell: CheckboxCell,
  width: 0.5,
  minWidth: 40,
});
